<template>
    <div :class="{ 'opfl-item-disabled': ! workflow.plugins_active }">
        <div class="opui-item">
            <div class="opui-left">
                <div class="op-flow-workflow-icons" :class="{ 'op-flow-workflow-icons-with-count': showItemCount, 'op-flow-workflow-icons-single': workflow.icons.length === 1 }" @click.prevent="editWorkflow(workflow)">
                    <div class="op-flow-icon" v-for="icon in workflow.icons">
                        <span v-html="icon"></span>
                    </div>

                    <div class="op-flow-workflow-icons-count" v-if="showItemCount">
                        {{ itemCountText }}
                    </div>
                </div>

                <RouterLink :to="`/workflows/${workflow.id}`">
                    <div class="opui-title">
                        <h3>
                            <i class="opui-fa opui-fa-warning opui-text-yellow" v-if="! workflow.plugins_active"></i>
                            {{ workflow.title }}
                        </h3>
                        <p>{{ workflow.description }}</p>
                    </div>
                </RouterLink>
            </div>

            <div class="opui-right">
                <div class="opfl-toggle-container">
                    <Toggle v-model="workflow.active" :checked="workflow.active" @change="toggleStatus" />
                </div>
                <a href="#" @click.prevent="duplicate(workflow)" class="opfl-delete-item">
                    <i class="opui-icon-clone"></i>
                </a>
                <a href="#" @click.prevent="remove" class="opfl-delete-item">
                    <i class="opui-icon-trash"></i>
                </a>
                <div>
                    <a class="opui-btn opui-btn-outline-secondary" @click.prevent="editWorkflow(workflow)">
                        {{ $e('Edit') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfirmModal from "../Global/ConfirmModal.vue"
import DuplicateModal from "../Workflows/Modals/DuplicateModal.vue"
import ErrorModal from "../Global/ErrorModal.vue"
import Toggle from "../Global/Toggle.vue"

export default {
    components: { DuplicateModal, Toggle },
    props: {
        workflow: { type: Object, required: true },
    },
    computed: {
        showItemCount() {
            return this.workflow.item_count > 1
        },

        itemCountText() {
            return '+' + (this.workflow.item_count - 1)
        }
    },
    methods: {
        duplicate(workflow) {
            this.$vfm.show({
                component: DuplicateModal,
                bind: { workflow: workflow },
                on: {
                    duplicated: (data) => {
                        console.log(data);
                        this.$emit('duplicated')
                    }
                }
            })
        },

        editWorkflow(workflow) {
            let errorText = ''

            if (workflow.plugins_active) {
                this.$router.push('/workflows/' + workflow.id)
            } else {
                let pluginList = 'required plugins';

                if (this.workflow.inactive_plugins) {
                    pluginList = '<ul class="opfl-plugin-list">';

                    this.workflow.inactive_plugins.map((item, index) => {
                        pluginList = pluginList + ('<li><strong>' + item.name + '</strong></li>')
                    })

                    pluginList += '</ul>'
                    errorText = "This workflow has been deactivated as it contains plugins that are not currently activated.<br>Please reactivate the following plugins to access and use this workflow:" + pluginList
                } else {
                    errorText = "This workflow has been deactivated as it contains plugins that are not currently activated.<br>Please reactivate "+pluginList+" to access and use this workflow."
                }

                // alert('');
                this.$vfm.show({
                    component: ErrorModal,
                    bind: { title: 'Warning', text: errorText },
                    on: {
                        confirm(close) {
                            close()
                        },
                    }
                })
            }
        },

        async toggleStatus() {
            let response = await this.$http.post('workflows/' + this.workflow.id + '/status', { 'active': this.workflow.active })
            let status   = await response.status

            if (status === 200) {
                this.$toast.success('Saved.')
                this.$emit('statusToggled')
            } else {
                console.info('Error when updating workflow status.', response.data)
            }
        },

        async remove() {
            let that = this

            this.$vfm.show({
                component: ConfirmModal,
                bind: { title: 'Delete Workflow', text: 'Are you sure you want to delete this workflow?' },
                on: {
                    async confirm(close) {
                        let response = await that.$http.post('workflows/' + that.workflow.id + '/delete')
                        let status   = await response.status

                        if (status === 200) {
                            that.$toast.success('Workflow deleted.')
                            that.$emit('deleted', that.workflow)
                        } else {
                            console.info('Error when deleting workflow.', response.data)
                        }
                        close()
                    },
                    cancel(close) {
                        close()
                    }
                }
            })
        },
    }
}
</script>

<style scoped>
.opfl-item-disabled {
    pointer-events: none;
    opacity: 0.5;
}

.opfl-item-disabled .opui-btn, .opfl-item-disabled .opfl-delete-item {
    pointer-events: auto;
}
</style>
